const state = {
  call_type: "normal",
  call_state: "",
  caller_number: "+10",
  caller_name: "Unknown Caller",
  queue_name: " ",
  lead_score: "",
  loyalty_points: "",
  hold_status: false,
  third_party_caller_name: "Unknown Caller2",
  third_party_caller_number: "+11",
  third_party_hold_status: false,
  isPrimaryCallDisconnected:false,
  caller_id: 0,
  contact_attributes: {},
  contact_id: 0,
  on_destroyed_flag: false,
  on_outbound_flag: false,
  dialedNumber: "",
  ivrNumber:"",
  start_time: "",
  end_time: "",
  displayHours: "00",
  displayMinutes: "00",
  displaySeconds: "00",
  onSetTimerFlag: false,
  callDuration: "",
  countryCode: { country: "us", code: "+1" },
  thirdPartyCountryCode: { country: "us", code: "+1" },
  fs_call_type: false,
  on_connecting_flag: false,
  notes_editor: false,
  number_pad: false,
  call_log_flag: false,
  external_id: "",
  call_type_name: "",

  freshchat_conversation_id: "",
  freshchat_channel_id: "",
  freshchat_user_id: "",
  freshchat_org_agent_id: "",
  freshchat_org_agent_name: "",
  freshchat_endcall_lock_flag: false,
  freshchat_pickedup_lock_flag: false,
  freshchat_missed_lock_flag: false,
  freshchat_connecting_lock_flag: false,
  freshchat_outboundcall_connected_lock:false,
  freshchat_agent_id: "",
  freshchat_conversation_app_id: "",
  freshwork_crm_contact_mcr_id: "",
  freshwork_crm_contact_id: "",
  isConferenceNumberPadUpdated:false
};

const mutations = {
  UPDATE_CALL_STATE: (state, call_state) => {
    state.call_state = call_state;
  },
  UPDATE_CALLER_NAME: (state, name) => {
    console.log("UPDATE_CALLER_NAME", name);
    state.caller_name = name;
  },
  UPDATE_CALLER_NUMBER: (state, number) => {
    state.caller_number = number;
  },
  UPDATE_QUEUE_NAME: (state, qname) => {
    state.queue_name = qname;
  },
  SET_CONTACT_ATTRIBUTES: (state, attributes) => {
    state.contact_attributes = attributes;
  },
  SET_CALLER_ID: (state, id) => {
    state.caller_id = id;
  },
  SET_CALL_TYPE: (state, type) => {
    state.call_type = type;
  },
  SET_CONTACT_ID: (state, id) => {
    state.contact_id = id;
  },
  SET_COUNTRY_CODE: (state, code) => {
    state.countryCode = code;
  },
  SET_THIRDPARTY_COUNTRY_CODE:(state,code)=>{
    state.thirdPartyCountryCode = code

  },
  SET_DIALED_NUMBER: (state, number) => {
    state.dialedNumber = number;
  },
  UPDATE_HOLD_STATUS: (state, status) => {
    state.hold_status = status;
  },
  UPDATE_THIRD_PARTY_HOLD_STATUS: (state, status) => {
    state.third_party_hold_status = status;
  },
  UPDATE_THIRD_PARTY_CALLER_NAME: (state, status) => {
    state.third_party_caller_name = status;
  },
  UPDATE_THIRD_PARTY_CALLER_NUMBER:(state,status) => {
    state.third_party_caller_number = status
  },
  SET_ONDESTROYED_FLAG: (state, flag) => {
    state.on_destroyed_flag = flag;
  },
  SET_START_TIME: (state, status) => {
    state.start_time = status;
  },
  SET_END_TIME: (state, status) => {
    state.end_time = status;
  },
  SET_DISPLAY_HOURS: (state, status) => {
    state.displayHours = status;
  },
  SET_DISPLAY_MINUTES: (state, status) => {
    state.displayMinutes = status;
  },
  SET_DISPLAY_SECONDS: (state, status) => {
    state.displaySeconds = status;
  },
  SET_ON_SET_TIMER_FLAG: (state, status) => {
    state.onSetTimerFlag = status;
  },
  SET_CALL_DURATION: (state, status) => {
    state.callDuration = status;
  },
  SET_ON_OUTBOUND_FLAG: (state, status) => {
    state.on_outbound_flag = status;
    console.log(
      "THIS IS THE PROOF THAT OUTBOUND HAS CHANGED",
      state.on_outbound_flag
    );
  },
  SET_FS_CALL_TYPE: (state, status) => {
    state.fs_call_type = status;
  },
  SET_ON_UPDATE_CONNECTING_FLAG: (state, status) => {
    state.on_connecting_flag = status;
  },
  UPDATE_NOTES_EDITOR: (state, status) => {
    state.notes_editor = status;
  },
  UPDATE_NUMBER_PAD: (state, status) => {
    state.number_pad = status;
  },
  SET_LEAD_SCORE: (state, status) => {
    state.lead_score = status;
  },
  SET_LOYALTY_POINTS: (state, status) => {
    state.loyalty_points = status;
  },
  UPDATE_CALL_LOG_FLAG: (state, status) => {
    state.call_log_flag = status;
  },
  UPDATE_EXTERNAL_ID: (state, status) => {
    state.external_id = status;
  },
  UPDATE_CALL_TYPE_NAME: (state, status) => {
    state.call_type_name = status;
  },
  SET_FRESHCHAT_CONVERSATION_ID: (state, status) => {
    state.freshchat_conversation_id = status;
  },
  SET_FRESHCHAT_CHANNEL_ID: (state, status) => {
    state.freshchat_channel_id = status;
  },
  SET_FRESHCHAT_USER_ID: (state, status) => {
    state.freshchat_user_id = status;
  },
  SET_FRESHCHAT_ORG_AGENT_ID: (state, status) => {
    state.freshchat_org_agent_id = status;
  },
  SET_FRESHCHAT_ORG_AGENT_NAME: (state, status) => {
    state.freshchat_org_agent_name = status;
  },
  SET_FRESHCHAT_ENDCALL_LOCK: (state, status) => {
    state.freshchat_endcall_lock_flag = status;
  },
  SET_FRESHCHAT_PICKEDUP_LOCK: (state, status) => {
    state.freshchat_pickedup_lock_flag = status;
  },
  SET_FRESHCHAT_MISSED_LOCK: (state, status) => {
    state.freshchat_missed_lock_flag = status;
  },
  SET_FRESHCHAT_OUTBOUND_CALL_CONNECTED_LOCK:(state,status)=>{
    state.freshchat_outboundcall_connected_lock = status;
  },
  SET_FRESHCHAT_AGENT_ID: (state, status) => {
    state.freshchat_agent_id = status;
  },
  SET_FRESHCHAT_CONVERSATION_APP_ID: (state, status) => {
    state.freshchat_conversation_app_id = status;
  },
  UPDATE_FCRM_MCR_ID: (state, status) => {
    state.freshwork_crm_contact_mcr_id = status;
    console.log("UPDATE_FCRM_MCR_ID", state.freshwork_crm_contact_mcr_id);
  },
  UPDATE_FCRM_CONTACT_ID: (state, status) => {
    state.freshwork_crm_contact_id = status;
    console.log("UPDATE_FCRM_CONTACT_ID", state.freshwork_crm_contact_id);
  },
  UPDATE_FCRM_ON_DESTROY: (state, status) => {
    state.freshchat_conversation_id = status;
    // state.freshchat_channel_id= status;
    state.freshchat_user_id = status;
    state.freshchat_org_agent_id = status;
    state.freshchat_org_agent_name = status;
    state.freshchat_agent_id = status;
    state.freshchat_conversation_app_id = status;
    state.freshwork_crm_contact_mcr_id = status;
    state.freshwork_crm_contact_id = status;
    console.log("UPDATE_FCRM_ON_DESTROY", state);
  },
  SET_FRESHCHAT_CONNECTING_LOCK: (state, status) => {
    state.freshchat_connecting_lock_flag = status;
  },
  SET_COUNTRY: (state, status) => {
    console.log("SET_COUNTRY", status);
    state.countryCode.country = status.country;
    state.countryCode.code = status.code;
  },
  IS_PRIMARY_CALL_DISCONNECTED : (state,status)=>{
    state.isPrimaryCallDisconnected = status
  },
  IS_CONFERENCE_NUMBER_PAD_UPDATED:(state,status)=>{
    state.isConferenceNumberPadUpdated = status
  },
  SET_IVR_NUMBER:(state,status)=>{
    state.ivrNumber = status
  }
  // SET_FRESHCHAT_CHANNEL_ID:(state,status)=>{     //newly added for channel id
  //   state.freshchat_channel_id = status
  // },
};

const actions = {
  updateCallState({ commit }, call_state) {
    commit("UPDATE_CALL_STATE", call_state);
  },
  updateCallerName({ commit }, name) {
    console.log('"THIS IS UPDATE CALLER NAME++++++++', name);
    commit("UPDATE_CALLER_NAME", name);
  },
  updateCallerNumber({ commit }, number) {
    commit("UPDATE_CALLER_NUMBER", number);
  },
  updateQueueName({ commit }, qname) {
    console.log('"THIS IS QUEUE NAME ACTION', qname);
    commit("UPDATE_QUEUE_NAME", qname);
  },
  setContactId({ commit }, id) {
    commit("SET_CONTACT_ID", id);
  },
  setCountryCode({ commit }, code) {
    commit("SET_COUNTRY_CODE", code);
    console.log("SET_COUNTRY_CODE", code);
  },
  setThirdPartyCountryCode({commit},code){
    commit('SET_THIRDPARTY_COUNTRY_CODE',code)
    console.log('SET_THIRDPARTY_COUNTRY_CODE',code)
  },
  setCountry({ commit }, country) {
    commit("SET_COUNTRY", country);
    console.log("SET_COUNTRY", country);
  },
  setDialedNumber({ commit }, number) {
    commit("SET_DIALED_NUMBER", number);
  },
  setIvrNumber({commit},ivrNumber){
    commit("SET_IVR_NUMBER", ivrNumber);

  },
  setCallType({ commit }, type) {
    commit("SET_CALL_TYPE", type);
  },
  setContactAttributes({ commit }, attributes) {
    console.log(JSON.stringify(attributes));
    console.log("THIS IS BEING CALLED FOR OBCALLS======", attributes);
    let name = "Unknown Caller";
    let caller_id = 0;
    let email = "";
    let first_name = "";
    let last_name = "";
    let mobile_number = "";
    let work_number = "";
    let lead_score = "";
    let loyalty_points = "";
    try {
      if (attributes.customerInfo) {
        console.log("THIS IS NOT PARSED", attributes);
        let info = JSON.parse(attributes.customerInfo.value);
        console.log("THIS IS CUSTOMERINFO", info);
        name = info.name;
        caller_id = info.caller_id;
        email = info.email;
        first_name = info.first_name;
        last_name = info.last_name;
        mobile_number = info.mobile_number;
        work_number = info.work_number;
        lead_score = info.lead_score;
        loyalty_points = info.loyalty_points;
      }
    } catch (e) {
      console.log(e);
    }

    commit("SET_CONTACT_ATTRIBUTES", attributes);
    commit("UPDATE_CALLER_NAME", name);
    commit("SET_CALLER_ID", caller_id);
    commit("SET_LEAD_SCORE", lead_score);
    commit("SET_LOYALTY_POINTS", loyalty_points);
  },

  setFreshChatContactAttributes({ commit }, attributes) {
    console.log("setFreshChatContactAttributes", attributes);
    commit("UPDATE_CALLER_NAME", attributes.contactName);
    commit("SET_CALLER_ID", attributes.callerId);
  },

  updateHoldStatus({ commit }, status) {
    console.log(status);
    commit("UPDATE_HOLD_STATUS", status);
  },
  updateThirdPartyHoldStatus({ commit }, status) {
    commit("UPDATE_THIRD_PARTY_HOLD_STATUS", status);
  },
  updateOnDestroyedFlag({ commit }, flag) {
    console.log("THIS IS ONDESTOYED COMMIT +++++", flag);
    commit("SET_ONDESTROYED_FLAG", flag);
  },
  updateOnOutboundFlag({ commit }, flag) {
    console.log("THIS IS OUTBOUND FLAG", flag);
    commit("SET_ON_OUTBOUND_FLAG", flag);
  },
  updateStartTime({ commit }, status) {
    // console.log(status);
    commit("SET_START_TIME", status);
  },
  updateEndTime({ commit }, status) {
    // console.log(status);
    commit("SET_END_TIME", status);
  },
  updateHours({ commit }, status) {
    commit("SET_DISPLAY_HOURS", status);
  },
  updateMinutes({ commit }, status) {
    // console.log(status);
    commit("SET_DISPLAY_MINUTES", status);
  },
  updateSeconds({ commit }, status) {
    // console.log(status);
    commit("SET_DISPLAY_SECONDS", status);
  },
  updateOnSetTimerFlag({ commit }, status) {
    // console.log(status);
    commit("SET_ON_SET_TIMER_FLAG", status);
  },
  updateCallDuration({ commit }, status) {
    commit("SET_CALL_DURATION", status);
  },
  updateFsCallType({ commit }, status) {
    commit("SET_FS_CALL_TYPE", status);
  },
  updateCallerId({ commit }, status) {
    commit("SET_CALLER_ID", status);
    console.log("UPDATE CALLER ID", status);
  },
  updateCallerName({ commit }, status) {
    commit("UPDATE_CALLER_NAME", status);
    console.log("UPDATE CALLER NAME", status);
  },
  updateConnectingFlag({ commit }, status) {
    commit("SET_ON_UPDATE_CONNECTING_FLAG", status);
  },
  updateNotesEditor({ commit }, status) {
    commit("UPDATE_NOTES_EDITOR", status);
    console.log("NOTES EDITOR UPDATED", status);
  },
  updateNumberPad({ commit }, status) {
    commit("UPDATE_NUMBER_PAD", status);
    console.log("NUMBER PAD UPDATED", status);
  },
  updateLeadScore({ commit }, status) {
    commit("SET_LEAD_SCORE", status);
    console.log("updateLeadScore called========", status);
  },
  updateLoyaltyPoints({ commit }, status) {
    console.log("updateLoyaltyPoints called========", status);
    commit("SET_LOYALTY_POINTS", status);
  },
  updateCallLogFlag({ commit }, status) {
    commit("UPDATE_CALL_LOG_FLAG", status);
    console.log("UPDATE CALL LOG FLAG CALLED", status);
  },
  updateExternalId({ commit }, status) {
    commit("UPDATE_EXTERNAL_ID", status);
    console.log("UPDATED EXTERNAL ID", status);
  },
  updateCallTypeName({ commit }, status) {
    commit("UPDATE_CALL_TYPE_NAME", status);
    console.log("UPDATE_CALL_TYPE_NAME", status);
  },
  setFreshChatConversationId({ commit }, status) {
    commit("SET_FRESHCHAT_CONVERSATION_ID", status);
    console.log("SET_FRESHCHAT_CONVERSATION_ID", status);
  },
  setFreshChatChannelId({ commit }, status) {
    commit("SET_FRESHCHAT_CHANNEL_ID", status);
    console.log("SET_FRESHCHAT_CHANNEL_ID", status);
  },
  setFreshchatUserId({ commit }, status) {
    commit("SET_FRESHCHAT_USER_ID", status);
    console.log("SET_FRESHCHAT_USER_ID", status);
  },
  setFreshchatOrgAgentId({ commit }, status) {
    commit("SET_FRESHCHAT_ORG_AGENT_ID", status);
    console.log("SET_FRESHCHAT_ORG_AGENT_ID", status);
  },
  setFreshchatOrgAgentName({ commit }, status) {
    commit("SET_FRESHCHAT_ORG_AGENT_NAME", status);
    console.log("SET_FRESHCHAT_ORG_AGENT_NAME", status);
  },
  setFreshchatEndCallLock({ commit }, status) {
    commit("SET_FRESHCHAT_ENDCALL_LOCK", status);
    console.log("SET_FRESHCHAT_ENDCALL_LOCK", status);
  },
  setFreshchatConnectingLock({ commit }, status) {
    commit("SET_FRESHCHAT_CONNECTING_LOCK", status);
    console.log("SET_FRESHCHAT_CONNECTING_LOCK", status);
  },
  setFreshchatPickedUpLock({ commit }, status) {
    commit("SET_FRESHCHAT_PICKEDUP_LOCK", status);
    console.log("SET_FRESHCHAT_PICKEDUP_LOCK", status);
  },
  setFreshchatMissedLock({ commit }, status) {
    commit("SET_FRESHCHAT_MISSED_LOCK", status);
    console.log("SET_FRESHCHAT_MISSED_LOCK", status);
  },
  setFreshchatOutboundCallConnectedLock({ commit }, status) {
    commit("SET_FRESHCHAT_OUTBOUND_CALL_CONNECTED_LOCK", status);
    console.log("SET_FRESHCHAT_OUTBOUND_CALL_CONNECTED_LOCK", status);
  },
  setFreshChatAgentId({ commit }, status) {
    commit("SET_FRESHCHAT_AGENT_ID", status);
    console.log("SET_FRESHCHAT_AGENT_ID", status);
  },
  setFreshChatConversationAppId({ commit }, status) {
    commit("SET_FRESHCHAT_CONVERSATION_APP_ID", status);
    console.log("SET_FRESHCHAT_CONVERSATION_APP_ID", status);
  },
  setFreshworksCrmContactDetails({ commit }, status) {
    commit("UPDATE_CALLER_NAME", status.fcrm_display_name);
    commit("UPDATE_FCRM_MCR_ID", status.fcrm_mcr_id);
    commit("UPDATE_FCRM_CONTACT_ID", status.fcrm_user_id);
  },
  updateFreshworksCrmOnDestroy({ commit }, status) {
    commit("UPDATE_FCRM_ON_DESTROY", status);
    console.log("updateFreshworksCrmOnDestroy call.js", status);
  },
  updateCountry({ commit }, status) {
    commit("SET_COUNTRY", status);
    console.log("SET_COUNTRY", status);
  },
  setFreshChatChannelId({ commit }, status) {
    commit("SET_FRESHCHAT_CHANNEL_ID", status);
    console.log("SET_FRESHCHAT_CHANNEL_ID", status);
  },
  updateThirdPartyCallerName({commit},status){
    commit('UPDATE_THIRD_PARTY_CALLER_NAME',status);
    console.log('UPDATE_THIRD_PARTY_CALLER_NAME',status)
  },
  updateThirdPartyCallerNumber({commit},status){
    commit('UPDATE_THIRD_PARTY_CALLER_NUMBER',status);
  },
  isPrimaryCallDisconnected({commit},status){
    commit('IS_PRIMARY_CALL_DISCONNECTED',status);
  },
  updateNumberPadConferenceEditor({commit},status){
    console.log("IS_CONFERENCE_NUMBER_PAD_UPDATED",status)
    commit("IS_CONFERENCE_NUMBER_PAD_UPDATED",status)
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
